import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import $ from 'jquery'
import ElementUI from 'element-ui';

import store from '../store'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

window.$ = $
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
Vue.prototype.$bus = new Vue()

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.withCredentials = true
Vue.config.productionTip = false
const servers = axios.create({
	// baseURL: '/api',
	baseURL: 'https://aimachefu.aimatech.com/',
	// 超时
	timeout: 10000000
})
servers.interceptors.request.use(config => {

	return config
})
Vue.prototype.$http = servers
new Vue({
	store,
	render: h => h(App),
}).$mount('#app')